<app-menu [hasChanges]="loadMenu" title="Movimientos de inventario"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="p-1 minScreen">
    <div class="pb-2">
        <h4>Seleccione el tipo de movimiento</h4>
        <div class="p-inputgroup">
            <div class="p-inputgroup-addon">
                <i class="pi pi-tag"></i>
            </div>
            <p-select [options]="lsTipoMovimientoTienda" [(ngModel)]="tipoMovimientoSelected" optionLabel="label"
                size="small" optionValue="id" placeholder="Seleccione el tipo de movimiento" class="w-full"></p-select>
        </div>
    </div>
    <p-accordion>
        <p-accordionTab header="Registro de movimientos" *ngIf="infoParametrizacion.cajeroAdmInventario">

            <div class="w-full" *ngIf="tipoMovimientoSelected > 0 && tipoMovimientoSelected > 1">
                <div *ngIf="tipoMovimientoSelected ==5">
                    <div *ngFor="let row of msgMovimiento">
                        <div class="p-message p-message-{{row.type}}">
                            <span [innerHtml]="row.text"></span>
                            &nbsp;<button class="p-button p-button-link p-0" icon="pi pi-eye" pButton
                                label="Mostrar Información" (click)="cargarInfo(row.index)"></button>
                        </div>
                    </div>
                </div>
                <h4 class="m-1">Relacione el concepto del movimiento</h4>
                <div class="p-inputgroup w-full">
                    <span class="p-inputgroup-addon"><i class="pi pi-pencil"></i></span>
                    <input type="text" pInputText placeholder="Ingrese el concepto" pSize="small"
                        [(ngModel)]="conceptoIng">
                </div>
                <div *ngIf="tipoMovimientoSelected ==6">
                    <h4 class="m-1">Relacione la tienda a donde se envia la mercancia</h4>
                    <div class="p-inputgroup">
                        <div class="p-inputgroup-addon">
                            <i class="pi pi-send"></i>
                        </div>
                        <p-select [options]="lsTiendas" [(ngModel)]="tiendaSelected" optionLabel="label" size="small"
                            optionValue="id" placeholder="Seleccione la tienda de destino" class="w-full"></p-select>
                    </div>
                </div>
                <p-card class="rounded" id="listProducts">
                    <ng-template pTemplate="content" styleClass="p-0">
                        <div class="text-center">
                            <h3><u>Listado de productos</u> </h3>
                        </div>
                        <div *ngFor="let item of arrayProducts; let index=index">
                            <div class="flex flex-wrap">
                                <div class="w-full md:w-7">
                                    <div class="p-inputgroup w-100">
                                        <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                                        <input type="text" pInputText placeholder="Ingrese el código de producto"
                                            [disabled]="!btnShow" [(ngModel)]="item.codigoProducto" pSize="small"
                                            (blur)="addProducts(index)">
                                    </div>
                                    <span [innerHtml]="item.descripcion"></span>
                                    <span [innerHtml]="item.error"></span>
                                    <p class="m-1 text-center">
                                        <button pButton class="p-button p-button-link" label="Eliminar"
                                            (click)="deleteProduct(index)"
                                            *ngIf="arrayProducts.length > 1 && btnShow"></button>
                                    </p>
                                </div>
                                <div class="w-11 md:w-4">
                                    <div class="p-inputgroup w-full">
                                        <span class="p-inputgroup-addon"><i class="pi">#</i></span>
                                        <div class="w-full">
                                            <p-inputNumber placeholder="Relacione la cantidad" class="w-full"
                                                [(ngModel)]="item.cantidad" [disabled]="!btnShow" size="small">
                                            </p-inputNumber>
                                        </div>
                                    </div>
                                    <div *ngIf="item.cantidad > 0" class="p-message p-message-success">Valor:
                                        {{(item.cantidad * item.precioProducto) |
                                        currency}}</div>
                                </div>
                                <div class="w-1 flex text-center align-items-start">
                                    <p *ngIf="item.error==''"><i class="pi pi-check-circle text-green-600 text-4x1"></i>
                                    </p>
                                    <p *ngIf="item.error!=''"><i
                                            class="pi pi-times-circle text-orange-600 text-4x1"></i>
                                    </p>
                                </div>
                            </div>
                            <p-divider></p-divider>
                        </div>
                        <div class="text-center">
                            <button pButton class="p-button p-button-danger" label="Nuevo" icon="pi pi-plus"
                                (click)="reload()"></button>
                            &nbsp;
                            <button pButton class="p-button p-button-info" label="Adicionar" icon="pi pi-plus"
                                (click)="addProducts(arrayProducts.length-1)" *ngIf="btnShow"></button>
                            &nbsp;
                            <button pButton label="Procesar" (click)="procesar()" class="p-button p-button-success"
                                icon="pi pi-check-circle" *ngIf="btnShow"></button>
                            &nbsp;<button pButton label="imprimir" class="p-button p-button-success"
                                (click)="printDiv('printMov','')" icon="pi pi-print" *ngIf="!btnShow"></button>
                        </div>
                    </ng-template>
                </p-card>
            </div>
        </p-accordionTab>
        <p-accordionTab header="Consulta de movimientos" [(selected)]="showConsulta">
            <div class="p-m-3">
                <div class="text-center">
                    <h5>Seleccione la fecha de consulta</h5><span class="p-input-icon-left">
                        <i class="pi pi-user"></i>
                        <p-calendar [(ngModel)]="dateQuery" dateFormat="yy-mm-dd"></p-calendar>
                    </span>
                    <button pButton icon="pi pi-search" class="p-button p-button-success p-mt-1" label="Consultar"
                        (click)="getInfoMovimientos()"></button>
                </div>
                <p-divider></p-divider>
                <div class="w-100">

                    <div *ngFor="let item of lsMovimientos">
                        <p># {{item.idRegistro}}: {{item.codBarras}} - {{item.descripcion}} actualmente tiene como
                            <b>inventario disponible: {{item.inventarioDisponible}}
                                {{item.unidadPresentacion}}</b>
                        </p>
                        <div class="hidden md:flex grid">
                            <div class="md:col-3">
                                <h4>Hora</h4>
                            </div>
                            <div class="md:col-6">
                                <h4>Descripción</h4>
                            </div>
                            <div class="md:col-3">
                                <h4>Cantidad - Valor</h4>
                            </div>
                        </div>
                        <div class="grid">
                            <div class="col-12 md:col-3"><span class="md:hidden">Hora:</span> &nbsp;{{item.fechaRegistro
                                |
                                date:'shortTime'}}
                            </div>
                            <div class="col-12 md:col-6"><span class="md:hidden">Descripción:</span>
                                &nbsp;{{item.observacion}}</div>
                            <div class="col-12 md:col-3"><span class="md:hidden">Cantidad - Valor:</span>
                                &nbsp;{{item.cantidad}} {{item.unidadPresentacion}} -
                                {{item.valorInventario | currency}}</div>
                            <div class="col-12">
                                <p-divider></p-divider>
                            </div>
                        </div>
                    </div>
                    <div class="grid align-items-center" *ngIf="lsMovimientos.length>0">
                        <div class="col-12 text-center p-4"><b>Nro. de movimientos: {{lsMovimientos.length}} <br> Total
                                cantidades: {{this.totalCantidades}}<br> Total
                                inventario: {{this.totalMovimiento | currency}}</b></div>
                    </div>
                    <div class="text-center" *ngIf="lsMovimientos.length>0"><button pButton label="imprimir"
                            class="p-button p-button-success" (click)="printDiv('printMov','',1)"
                            icon="pi pi-print"></button></div>
                </div>
            </div>
        </p-accordionTab>
    </p-accordion>

</div>
<div id="printMov" class="hidden">
    <div style="text-align: left;">
        <div *ngFor="let item of arrayProductsPrint">
            <p>Concepto: {{item.observacion}}</p>
            <p>Producto: {{item.text}}</p>
            <p>Cantidad: {{item.cantidad}}</p>
            <p>Valor :<b>{{(item.precioProducto * item.cantidad )| currency}}</b></p>
            <div style="text-align: center;">-----------------------------</div>
        </div>
        <div style="text-align: center;">
            <p>Nro. de movimientos: <b>{{arrayProductsPrint.length}}</b></p>
            <p>Cantidades:{{totalCantidades}} </p>
            <p>Valor total : {{totalMovimiento | currency}}</p>
        </div>
        <div>-----------------------------</div>
    </div>
</div>

<p-toast></p-toast>
<app-footer></app-footer>